import { render, staticRenderFns } from "./AuctionFormLots.vue?vue&type=template&id=0c7b9757&scoped=true"
import script from "./AuctionFormLots.vue?vue&type=script&lang=js"
export * from "./AuctionFormLots.vue?vue&type=script&lang=js"
import style0 from "./AuctionFormLots.vue?vue&type=style&index=0&id=0c7b9757&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7b9757",
  null
  
)

export default component.exports